export enum PasswordExpiredError {
  Throttled = '<b>This request have been throttled!</b><br>Please try again.',
  WeakPassword = '<b>Password is to weak!</b><br>At least one number, one lowercase and one uppercase letter. At least eight characters that are letters, numbers or the underscore',
  SamePassword = '<b>Password cannot be the same as before</b><br>Please try again.',
  UpdateFailed = '<b>Could not update password!</b><br>Please try again.',
  IncorrectPassword = '<b>Old password was incorrect!</b><br>Please try again.',
  InvalidUser = '<b>User or password is invalid!</b><br>Please try again.',
}
